// Store implementation matching PRD functional pattern
type Listener = (state: Record<string, unknown>) => void;

const state: Record<string, unknown> = {};
const listeners = new Set<Listener>();

// Load initial state from localStorage
const stored = localStorage.getItem('lunai_user_data');
if (stored) {
  try {
    Object.assign(state, JSON.parse(stored));
  } catch (error) {
    console.error('Failed to load stored state:', error);
  }
}

export const store = {
  get: <T = unknown>(key: string): T => state[key] as T,

  set: (key: string, value: unknown): void => {
    state[key] = value;

    // Save to localStorage (excluding large data)
    try {
      const toStore = { ...state };
      if (toStore.selfie && (toStore.selfie as string).length > 10000) {
        toStore.selfie = 'stored'; // Just mark that we have a selfie
      }
      if (toStore.cameraStream) {
        delete toStore.cameraStream; // Don't store media streams
      }
      localStorage.setItem('lunai_user_data', JSON.stringify(toStore));
    } catch (error) {
      console.error('Failed to save state:', error);
    }

    // Notify listeners
    listeners.forEach(listener => listener(state));
  },

  on: (listener: Listener): (() => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  getAll: (): Record<string, unknown> => ({ ...state }),

  clear: (): void => {
    Object.keys(state).forEach(key => delete state[key]);
    localStorage.removeItem('lunai_user_data');
    listeners.forEach(listener => listener(state));
  }
};